import LandingPage from "views/lysto/LandingPage"; // Import LandingPage component
import PrivacyPolicy from "views/lysto/LandingPage/PrivacyPolicy"; // Import PrivacyPolicy component
import TermsOfService from "views/lysto/LandingPage/TermsOfService"; // Import TermsOfService component

const routes_json = {
  routes: [
    { name: "Inbox" },
    { name: "InboxDetails" },
    { name: "Meetings" },
    { name: "MeetingDetails" },
    { name: "MeetingAnalysis" },
    { name: "Deals" },
    { name: "DealDetails" },
    { name: "Contacts" },
    { name: "ContactDetails" },
    { name: "Accounts" },
    { name: "AccountDetails" },
    { name: "Workflows" },
    { name: "Settings" },
    { name: "Leo" },
    { name: "Reports" },
    { name: "Spark" },
    { name: "Agents" },
    { name: "AgentDetail" },
    { name: "LandingPage" }, // Add LandingPage to allowed routes
    { name: "PrivacyPolicy" }, // Add PrivacyPolicy to allowed routes
    { name: "TermsOfService" }, // Add TermsOfService to allowed routes
  ],
};

const allowedRouteNames = routes_json.routes.map((route) => route.name);

const routes = [
  {
    name: "LandingPage",
    layout: "/",
    path: "",
    component: LandingPage,
  },
  {
    name: "PrivacyPolicy",
    layout: "/",
    path: "privacy",
    component: PrivacyPolicy,
    hidden: true,
  },
  {
    name: "TermsOfService",
    layout: "/",
    path: "terms",
    component: TermsOfService,
    hidden: true,
  },
].filter((route) => allowedRouteNames.includes(route.name));

export default routes;
